import { render, staticRenderFns } from "./workerClueAddForm.vue?vue&type=template&id=a05df51c"
import script from "./workerClueAddForm.vue?vue&type=script&lang=js"
export * from "./workerClueAddForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports